"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInsightsPeriodBuckets = exports.isInsightsWeeklyAllowed = exports.INSIGHTS_WEEKLY_MAX_RANGE_DAYS = exports.INSIGHTS_BUCKET_COUNT_BY_PERIOD = exports.DEFAULT_INSIGHTS_PERIOD = exports.INSIGHTS_PERIODS = void 0;
const fiscal_year_1 = require("./fiscal-year");
exports.INSIGHTS_PERIODS = ["weekly", "monthly", "yearly"];
exports.DEFAULT_INSIGHTS_PERIOD = "monthly";
exports.INSIGHTS_BUCKET_COUNT_BY_PERIOD = { weekly: 12, monthly: 12, yearly: 5 };
exports.INSIGHTS_WEEKLY_MAX_RANGE_DAYS = 13 * 30;
const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
const isInsightsWeeklyAllowed = (range) => Boolean(range) &&
    range.end.getTime() - range.start.getTime() <= exports.INSIGHTS_WEEKLY_MAX_RANGE_DAYS * DAY_IN_MILLISECONDS;
exports.isInsightsWeeklyAllowed = isInsightsWeeklyAllowed;
const getInsightsPeriodBuckets = ({ period, fiscalYearStartMonth, firstActivityAt, range, now = new Date(), }) => {
    if (!firstActivityAt) {
        return [];
    }
    const buckets = range
        ? getRangeBuckets(period, fiscalYearStartMonth, range)
        : getLatestBuckets(period, fiscalYearStartMonth, now);
    return buckets.filter((bucket) => bucket.end > firstActivityAt);
};
exports.getInsightsPeriodBuckets = getInsightsPeriodBuckets;
const getLatestBuckets = (period, fiscalYearStartMonth, now) => {
    const bucketCount = exports.INSIGHTS_BUCKET_COUNT_BY_PERIOD[period];
    const lastStart = getPeriodStart(period, fiscalYearStartMonth, now);
    const firstStart = addPeriods(period, lastStart, -(bucketCount - 1));
    return Array.from({ length: bucketCount }, (_, index) => ({
        start: addPeriods(period, firstStart, index),
        end: addPeriods(period, firstStart, index + 1),
    }));
};
const getRangeBuckets = (period, fiscalYearStartMonth, range) => {
    const rangeStart = toUtcDay(range.start);
    const rangeEnd = new Date(toUtcDay(range.end).getTime() + DAY_IN_MILLISECONDS);
    const buckets = [];
    for (let start = getPeriodStart(period, fiscalYearStartMonth, rangeStart); start < rangeEnd; start = addPeriods(period, start, 1)) {
        const end = addPeriods(period, start, 1);
        buckets.push({
            start: start < rangeStart ? rangeStart : start,
            end: end > rangeEnd ? rangeEnd : end,
        });
    }
    return buckets;
};
const getPeriodStart = (period, fiscalYearStartMonth, date) => {
    if (period === "weekly") {
        const day = toUtcDay(date);
        const daysSinceMonday = (day.getUTCDay() + 6) % 7;
        return new Date(day.getTime() - daysSinceMonday * DAY_IN_MILLISECONDS);
    }
    if (period === "monthly") {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
    }
    return (0, fiscal_year_1.getFiscalYearWindowStart)(fiscalYearStartMonth, 0, date);
};
const addPeriods = (period, date, count) => {
    if (period === "weekly") {
        return new Date(date.getTime() + count * 7 * DAY_IN_MILLISECONDS);
    }
    const months = period === "monthly" ? count : count * 12;
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + months, 1));
};
const toUtcDay = (date) => new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
